export const AUTHENTICATION_TYPES_VALUES = <const>[
  'certificado_digital',
  'email',
  'assinatura_digital',
  'whatsapp',
  'sms',
];

export type AuthenticationType = typeof AUTHENTICATION_TYPES_VALUES[number];
